import styled, { css } from 'styled-components'
import { Color, transition } from '../../theme'

type TButtonSize = 'small' | 'medium' | 'large' | ''
type TButton = {
  size: TButtonSize
  isBan: boolean
  active: boolean
}

const handlePadding = (size: TButtonSize) => {
  switch (size) {
    case 'small':
      return '0 15px'
    case 'medium':
      return '0 38px'
    case 'large':
      return '0 45px'
    default:
      break
  }
}

const createBoundary = css<TButton>`
  font-size: ${(props) => (props.size === 'small' ? `14px` : `16px`)};
  padding: ${(props) => handlePadding(props.size)};
  border-radius: ${(props) => (props.size === 'small' ? '15px' : '20px')};
  transition: ${transition(['background-color'])};
  height: ${(props) => (props.size === 'small' ? '24px' : '32px')};
`
const Button = styled.button<TButton>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: ${(props) => (props.isBan ? 'not-allowed' : 'pointer')};
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
    `}
  white-space: nowrap;
`
export const ContainedButton = styled(Button)`
  color: white;
  background-color: ${Color['theme-1']};
  transition: ${transition(['background-color'])};
  ${createBoundary};
  :hover {
    background-color: ${Color['theme-2']};
  }
  a {
    color: white;
  }
`
export const OutlinedButton = styled(Button)`
  color: ${Color['theme-1']};
  border: 1px solid;
  border-color: ${Color['theme-1']};
  background-color: transparent;
  ${createBoundary};
  :hover {
    color: white;
    background-color: ${Color['theme-1']};
  }
`
export const DefaultButton = styled(Button)`
  color: ${Color['theme-1']};
  background-color: white;
  transition: ${transition(['opacity'])};
  ${createBoundary};
  :hover {
    opacity: 0.9;
  }
`
export const PaginationButton = styled(Button)`
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin: 10px;
  color: ${(props) => (props.active ? 'white' : Color['grey-6'])};
  background-color: ${(props) => (props.active ? Color['theme-1'] : 'white')};
  margin: 5px;
  transition: ${transition(['color', 'border', 'background-color'])};
  svg {
    color: ${Color['grey-9']};
    fill: currentColor;
  }
  &:hover {
    color: ${(props) => (props.isBan ? Color['grey-9'] : 'white')};
    background-color: ${(props) => (props.isBan ? 'white' : Color['theme-1'])};
    svg {
      color: ${(props) => (props.isBan ? Color['grey-6'] : 'white')};
    }
  }
`
